import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="email5-a"
            d="M14.9491974,3.6844582 L8.63789848,8.91217026 C8.26786063,9.21867631 7.73213937,9.21867631 7.36210152,8.91217026 L1.05080255,3.6844582 C1.01784432,3.78365077 1,3.8897415 1,4 L1,12 C1,12.5522847 1.44771525,13 2,13 L14,13 C14.5522847,13 15,12.5522847 15,12 L15,4 C15,3.8897415 14.9821557,3.78365077 14.9491974,3.6844582 Z M2,2 L14,2 C15.1045695,2 16,2.8954305 16,4 L16,12 C16,13.1045695 15.1045695,14 14,14 L2,14 C0.8954305,14 1.3527075e-16,13.1045695 0,12 L0,4 C-1.3527075e-16,2.8954305 0.8954305,2 2,2 Z M1.78969311,3 L7.36632836,7.60339717 C7.73459042,7.90738989 8.26639924,7.90859432 8.63603446,7.60627277 L14.267921,3 L1.78969311,3 Z"/>
    </defs>
    <use fillRule="evenodd" xlinkHref="#email5-a"/>
  </svg>
);
